// 알림센터(공지/주문 알림) 공통 타입 + 관리자 공지 발송 스키마.

import { z } from "zod";

export type NotificationKind = "notice" | "order";

export interface NotificationDto {
  id: string;
  kind: NotificationKind;
  title: string;
  body: string;
  linkUrl: string | null;
  read: boolean;
  createdAt: string;
}

// 관리자 공지/이벤트 발송 입력. 전체 사용자에게 fan-out 되며, silent 가 아니면 푸시도 전송된다.
//  - silent=true: 조용히 발송(개선항목 10). 앱 내 알림센터에는 남기되 푸시 알림은 보내지 않는다.
export const adminBroadcastInputSchema = z.object({
  title: z.string().trim().min(1, "제목을 입력하세요.").max(60),
  body: z.string().trim().min(1, "내용을 입력하세요.").max(1000),
  silent: z.boolean().optional().default(false),
});
export type AdminBroadcastInput = z.infer<typeof adminBroadcastInputSchema>;
